import React from 'react';
import { Calendar, Clock, Package } from 'lucide-react';
import { formatCrewTime } from './CrewRunSheetPriority';
import { crewEquipmentResponsibilityText, type CrewTimeLabel, type EquipmentArrivalLabel } from '../crewPortalDisplay';

export type CrewEventCardJob = {
  eventDate?: string;
  startTime?: string | null;
  myCallTime?: string | null;
  myTimeLabel?: CrewTimeLabel;
  equipmentArrivalLabel?: EquipmentArrivalLabel;
  equipmentPickupTime?: string | null;
};

const formatDate = (value?: string) => value && value !== 'TBD'
  ? new Date(`${value.split('T')[0]}T12:00:00`).toLocaleDateString('en-NZ', { day: 'numeric', month: 'short', year: 'numeric' })
  : 'Date TBD';

export function CrewEventCardDetails({ job }: { job: CrewEventCardJob }) {
  return (
    <div className="grid grid-cols-2 gap-2" aria-label="Event essentials">
      <div className="col-span-2 flex items-center gap-2 rounded-xl border border-white/5 bg-black/30 px-3 py-2 text-xs font-semibold text-slate-300">
        <Calendar size={13} className="text-brand-neonPink" /> {formatDate(job.eventDate)}
      </div>
      <div className="rounded-xl border border-brand-neonBlue/20 bg-brand-neonBlue/5 p-3">
        <p className="text-[9px] font-black uppercase tracking-wider text-brand-neonBlue">{job.myTimeLabel || 'Your Call Time'}</p>
        <p className="mt-1 text-base font-black text-white">{formatCrewTime(job.myCallTime)}</p>
      </div>
      <div className="rounded-xl border border-brand-neonPink/20 bg-brand-neonPink/5 p-3">
        <p className="flex items-center gap-1 text-[9px] font-black uppercase tracking-wider text-brand-neonPink"><Clock size={11} /> Event Start</p>
        <p className="mt-1 text-base font-black text-white">{formatCrewTime(job.startTime)}</p>
      </div>
      <div className="col-span-2 rounded-xl border border-white/5 bg-black/30 px-3 py-2.5">
        <p className="flex items-center gap-2 text-xs font-bold text-slate-300">
          <Package size={14} className="shrink-0 text-slate-500" />
          {crewEquipmentResponsibilityText(job.equipmentArrivalLabel)}
        </p>
        {job.equipmentPickupTime && (
          <p className="mt-1 pl-[22px] text-[11px] font-semibold text-slate-400">
            Equipment pickup: {formatCrewTime(job.equipmentPickupTime)}
          </p>
        )}
      </div>
    </div>
  );
}
